import { render, staticRenderFns } from "./ClientRequestersTableExpansion.vue?vue&type=template&id=450517f6&scoped=true&"
import script from "./ClientRequestersTableExpansion.vue?vue&type=script&lang=js&"
export * from "./ClientRequestersTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./ClientRequestersTableExpansion.vue?vue&type=style&index=0&id=450517f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450517f6",
  null
  
)

export default component.exports